import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule,} from './app-routing.module';
import {AppComponent} from './app.component';
import {AboutComponent} from './about/about.component';
import {ServicesComponent} from './services/services.component';
import {ProductsComponent} from './products/products.component';
import {LocationComponent} from './location/location.component';
import {HomeComponent} from './home/home.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {APP_BASE_HREF, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {SlideshowModule} from 'ng-simple-slideshow';
import {ProductsKaivuriComponent} from './products/products-kaivuri/products-kaivuri.component';
import {ProductsVesakkoComponent} from './products/products-vesakko/products-vesakko.component';
import {ProductsErikoisComponent} from './products/products-erikois/products-erikois.component';
import {RouterService} from './RouterService';
import {MobileSidebarComponent} from './mobile-sidebar/mobile-sidebar.component';
import {ModalComponent} from './modal/modal.component';
import {FormsModule} from '@angular/forms';
import {LanguageHelper} from './LanguageHelper';

// tslint:disable-next-line:typedef
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        AboutComponent,
        ServicesComponent,
        ProductsComponent,
        LocationComponent,
        HomeComponent,
        ProductsKaivuriComponent,
        ProductsVesakkoComponent,
        ProductsErikoisComponent,
        MobileSidebarComponent,
        ModalComponent
    ],
    imports: [
        BrowserModule,
        SlideshowModule,
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            defaultLanguage: 'fi',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        FormsModule
    ],
    providers: [{provide: APP_BASE_HREF, useValue: '/'}, {
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    }, RouterService, LanguageHelper],
    bootstrap: [AppComponent]
})
export class AppModule {

}
